import { render, staticRenderFns } from "./RulesSqp.vue?vue&type=template&id=008a0c28&"
import script from "./RulesSqp.vue?vue&type=script&lang=js&"
export * from "./RulesSqp.vue?vue&type=script&lang=js&"
import style0 from "./RulesSqp.vue?vue&type=style&index=0&id=008a0c28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports